// src/components/Footer/Footer.js
import React from "react";
import { Link as MuiLink } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Grid, Typography, Link } from "@mui/material";
import {
  Twitter,
  Facebook,
  Instagram,
  LinkedIn,
} from "@mui/icons-material";
import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <div className={styles.footerContainer}>
      {/* Background effects */}
      <div className={styles.binaryBackground}></div>
      <div className={styles.circuitLines}></div>
      
      <Grid
        container
        spacing={0}
        className={styles.footer}
        justifyContent="center"
      >
        {/* Logo & Social */}
        <Grid item xs={12} md={4} className={styles.footerColumn}>
          <Typography className={styles.logo}>AI-MEBOT</Typography>
          <Typography className={styles.description}>
            AI MEBOT provides intelligent automation solutions for businesses,
            streamlining processes and enhancing productivity.
          </Typography>

          <div className={styles.socialIcons}>
            <Twitter className={styles.icon} />
            <Facebook className={styles.icon} />
            <Instagram className={styles.icon} />
            <LinkedIn className={styles.icon} />
          </div>
        </Grid>

        {/* Useful Links */}
        
        <Grid item xs={12} md={2} className={styles.footerColumn}>
  <Typography className={styles.sectionTitle}>Useful Links</Typography>
  <ul className={styles.linkList}>
    <li>
      <MuiLink
        component={RouterLink}
        to="/"
        className={styles.link}
      >
        Home
      </MuiLink>
    </li>

    <li>
      <MuiLink
        component={RouterLink}
        to="/servicedescri"
        className={styles.link}
      >
        Services
      </MuiLink>
    </li>

    <li>
      <MuiLink
        component={RouterLink}
        to="/ai-agent"
        className={styles.link}
      >
        Ai-Agents
      </MuiLink>
    </li>

    <li>
      <MuiLink
        component={RouterLink}
        to="/voiceplots"
        className={styles.link}
      >
        voiceplots
      </MuiLink>
    </li>
  </ul>
</Grid>


        {/* Our Services */}
        <Grid item xs={12} md={3} className={styles.footerColumn}>
          <Typography className={styles.sectionTitle}>Our Services</Typography>
          <ul className={styles.linkList}>
            <li><span className={styles.serviceText}>Web AI MEBOT Tool</span></li>
            <li><span className={styles.serviceText}>AI MEBOT Remediation</span></li>
            <li><span className={styles.serviceText}>AI MEBOT Monitoring</span></li>
            <li><span className={styles.serviceText}>Our Philosophy & Process</span></li>
            <li><span className={styles.serviceText}>Web AI MEBOT Consulting</span></li>
            <li><span className={styles.serviceText}>Multimedia MEBOT</span></li>
          </ul>
        </Grid>
      </Grid>

      <div className={styles.bottomSection}>
        <div className={styles.techLine}></div>
        <Typography className={styles.copyright}>
          © 2026 AI MEBOT. All rights reserved.
        </Typography>
      </div>
    </div>
  );
};

export default Footer;